/**
 * Com que botão do mouse o personagem anda (Configurações › Jogabilidade, Renato 28/10/2026).
 * Padrão: botão DIREITO, como no UO; o esquerdo fica para selecionar, falar, saquear e atravessar portal.
 * "esquerdo" volta ao jeito antigo: o esquerdo faz tudo e o direito só abre os menus.
 * No toque (celular/tablet) o toque sempre anda, qualquer que seja a escolha.
 * É preferência do navegador: leitura e gravação em try/catch; sem storage vale o padrão.
 */
export type BotaoAndar = 'direito' | 'esquerdo';

const CHAVE = 'uoidle.jogo.botaoAndar';

export function lerBotaoAndar(): BotaoAndar {
  try {
    return localStorage.getItem(CHAVE) === 'esquerdo' ? 'esquerdo' : 'direito';
  } catch {
    return 'direito';
  }
}

export function gravarBotaoAndar(botao: BotaoAndar) {
  try { localStorage.setItem(CHAVE, botao); } catch { /* sem storage: vale o padrão */ }
}
